import httpClientAnnouncements from '../api/httpClientAnnouncements';

export const getAllAnnouncements = async ({ pageNumber = 1, pageSize = 10, isPublished, category, search } = {}) => {
  const response = await httpClientAnnouncements.get('/api/announcements/Announcement/GetAll', {
    params: { pageNumber, pageSize, isPublished, category, search },
  });
  return response.data;
};

export const getAnnouncementById = async (id) => {
  const response = await httpClientAnnouncements.get(`/api/announcements/Announcement/GetById/${id}`);
  return response.data;
};

export const createAnnouncement = async (payload, coverImage, attachments) => {
  const formData = new FormData();
  
  // Text fields
  formData.append('Title', payload.title || '');
  formData.append('Content', payload.content || '');
  formData.append('Category', payload.category ?? 0);
  if (payload.relatedEntityId) {
    formData.append('RelatedEntityId', payload.relatedEntityId);
  }
  formData.append('SendChannels', payload.sendChannels ?? 8);
  formData.append('TargetType', payload.targetType ?? 0);
  if (payload.targetData && Array.isArray(payload.targetData) && payload.targetData.length > 0) {
    payload.targetData.forEach((item, index) => {
      formData.append(`TargetData[${index}]`, item);
    });
  }
  formData.append('Visibility', payload.visibility ?? 0);
  formData.append('AutomationType', payload.automationType ?? 0);
  if (payload.automationRule) {
    formData.append('AutomationRule', payload.automationRule);
  }
  formData.append('IsPublished', payload.isPublished === true ? 'true' : 'false');
  if (payload.emailTemplateId) {
    formData.append('EmailTemplateId', payload.emailTemplateId);
  }
  if (payload.publishAt) {
    formData.append('PublishAt', payload.publishAt);
  }
  if (payload.expireAt) {
    formData.append('ExpireAt', payload.expireAt);
  }
  
  // Files
  if (coverImage instanceof File) {
    formData.append('coverImage', coverImage);
  }
  if (attachments && Array.isArray(attachments)) {
    attachments.forEach((file) => {
      if (file instanceof File) {
        formData.append('attachments', file);
      }
    });
  }
  
  const response = await httpClientAnnouncements.post('/api/announcements/Announcement/Create', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const updateAnnouncement = async (payload) => {
  const response = await httpClientAnnouncements.put('/api/announcements/Announcement/Update', payload);
  return response.data;
};

export const deleteAnnouncement = async (id) => {
  const response = await httpClientAnnouncements.delete(`/api/announcements/Announcement/Delete/${id}`);
  return response.data;
};

export const publishAnnouncement = async (id) => {
  const response = await httpClientAnnouncements.post(`/api/announcements/Announcement/Publish/${id}`);
  return response.data;
};

export const updateCoverImage = async (id, coverImage) => {
  const formData = new FormData();
  if (coverImage instanceof File) {
    formData.append('coverImage', coverImage);
  }
  const response = await httpClientAnnouncements.put(`/api/announcements/Announcement/UpdateCoverImage/${id}/CoverImage`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const updateAttachments = async (id, keepAttachmentUrls, newFiles) => {
  const formData = new FormData();
  
  // Keep attachment URLs
  // If keepAttachmentUrls is null, don't send it (backend will handle)
  // If it's an empty array [], send empty array to delete all
  // If it has items, send each item
  if (keepAttachmentUrls !== null && keepAttachmentUrls !== undefined) {
    if (Array.isArray(keepAttachmentUrls)) {
      if (keepAttachmentUrls.length === 0) {
        // Empty array - delete all existing attachments
        formData.append('keepAttachmentUrls', '[]');
      } else {
        // Send each URL
        keepAttachmentUrls.forEach((url, index) => {
          formData.append(`keepAttachmentUrls[${index}]`, url);
        });
      }
    }
  }
  
  // New files
  if (newFiles && Array.isArray(newFiles) && newFiles.length > 0) {
    newFiles.forEach((file) => {
      if (file instanceof File) {
        formData.append('newFiles', file);
      }
    });
  }
  
  const response = await httpClientAnnouncements.put(`/api/announcements/Announcement/UpdateAttachments/${id}/Attachments`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export default {
  getAllAnnouncements,
  getAnnouncementById,
  createAnnouncement,
  updateAnnouncement,
  deleteAnnouncement,
  publishAnnouncement,
  updateCoverImage,
  updateAttachments,
};



